// extracted by mini-css-extract-plugin
export default {"content":"InventorySheetPage_content__ZvDAh"};